const STATUS_SELECTOR: string = '[data-status]';

export class StatusUI {

  private hiddenElementsIfServerOffline: JQuery[] = [$('.panel--mod-space'), $('[data-wi-link]'), $('.layout--map')];

  public constructor(private $base: JQuery) {}

  public hideElementsIfServerOffline() {
    this.hiddenElementsIfServerOffline.map((el) => {
      $(el).hide();
    });
    $('[data-offline-hint]').show();
  }

  public showHiddenElementsIfServerOnline() {
    this.hiddenElementsIfServerOffline.map((el) => {
      $(el).show();
    });

    $('[data-offline-hint]').hide();
  }

  public isServerOnline() : boolean {
    return $('[data-server-state]').find('.fancy-checkbox').hasClass('is-active');
  }
}

export function createStatusUIInstances(): StatusUI[] {
  const $base = $(STATUS_SELECTOR);
  const instances: StatusUI[] = [];
  $base.each((i, e) => {
    instances.push(new StatusUI($(e)))
  });

  return instances;

}
